jQuery(document).ready(function ($) {

    let sidebarBlocks = $(".wens-press-pro-sidebar-popup-save");
    let sidebarButtons = $(".wens-press-pro-sidebar-popup-save-button");

    if (sidebarBlocks.length === 0 || sidebarButtons.length === 0) {
        console.warn("No sidebar blocks or buttons found.");
        return;
    }

    sidebarBlocks.each(function (index) {

        let sidebarElement = $(this);
        let sidebarButton = sidebarButtons.eq(index);

        let width = sidebarElement.data("width") || 50;
        let position = sidebarElement.data("position") || "left";

        /**
         * Initial Position
         */
        function closeSidebar() {
            if ($(window).width() <= 480) {
                sidebarElement.css(position, "-100%");
            } else {
                sidebarElement.css(position, `-${width}%`);
            }
        }

        /**
         * Open Sidebar
         */
        function openSidebar() {
            sidebarElement.css(position, "0");
        }

        /**
         * Set Width
         */
        function updateSidebar() {

            if ($(window).width() <= 480) {
                sidebarElement.css("width", "100%");
            } else {
                sidebarElement.css("width", width + "%");
            }

            /**
             * Add Close Button Once
             */
            if (sidebarElement.find(".wens-press-pro-sidebar-close").length === 0) {

                let closeButton = $(`
                    <button class="wens-press-pro-sidebar-close">
                        &times;
                    </button>
                `);

                sidebarElement.append(closeButton);

                closeButton.on("click", function () {
                    closeSidebar();
                });
            }
        }

        /**
         * Initialize
         */
        updateSidebar();
        closeSidebar();

        /**
         * Open Button Click
         */
        sidebarButton.on("click", function () {
            openSidebar();
        });

        /**
         * Resize
         */
        $(window).on("resize", function () {
            updateSidebar();
            closeSidebar();
        });

    });

});